

























































import { Vue, Component } from 'vue-property-decorator';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ServiceHookDialog from './service-hook-dialog.component.vue';
import WebhookForm from './webhook-form.entity';
import WebhookService from './webhook.service';
import WebhookListItem from './webhook-list-item.entity';
import ServiceHookList from './service-hook-list.component.vue';

@Component({
  components: { ServiceHookDialog, ServiceHookList, ModalWarning },
})

export default class ServiceHook extends Vue {
  private showDialog: boolean = false;

  private showWarningDialog: boolean = false;

  private readOnlyDialog: boolean = false;

  private webhookList: WebhookListItem[] = [];

  private editingWebhook: WebhookForm = new WebhookForm();

  private deletingWebhookId: string = '';

  private loadingWebhooks: boolean = true;

  private businessUnitId: string = '';

  private openNewWebhookDialog(): void {
    this.editingWebhook = new WebhookForm();
    this.showDialog = true;
  }

  private setShowDialog(value: boolean): void {
    this.showDialog = value;
    if (!value) {
      this.editingWebhook = new WebhookForm();
      this.readOnlyDialog = false;
    }
  }

  private closeWarningDialog(): void {
    this.showWarningDialog = false;
  }

  private updateField(field: string, value: any): void {
    this.editingWebhook[field] = value;
  }

  private editWebhook(webhook: WebhookListItem): void {
    this.editingWebhook = new WebhookForm({
      ...webhook,
      webhookTypeId: webhook.webhookType.id,
    });
    this.readOnlyDialog = webhook.readOnly;
    this.showDialog = true;
  }

  private deleteWebhook(webhookId: string): void {
    this.deletingWebhookId = webhookId;
    this.showWarningDialog = true;
  }

  private confirmWebhookDelete(): void {
    this.closeWarningDialog();
    WebhookService.deleteWebhook(this.businessUnitId, this.deletingWebhookId)
      .then(this.loadWebhooks);
  }

  private saveWebhook(): void {
    const saveService: Function = this.editingWebhook.id
      ? WebhookService.putWebhook
      : WebhookService.postWebhook;
    saveService(this.businessUnitId, this.editingWebhook).then(this.loadWebhooks);
  }

  private loadWebhooks(): void {
    if (!this.businessUnitId) return;
    this.loadingWebhooks = true;
    WebhookService.getWebhooks(this.businessUnitId).then((webhookList: WebhookListItem[]) => {
      this.webhookList = webhookList;
    }).finally(() => {
      this.loadingWebhooks = false;
    });
  }

  private created(): void {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.businessUnitId !== businessUnit.id) {
        this.businessUnitId = businessUnit.id;
        this.loadWebhooks();
      }
    });
    this.loadWebhooks();
  }
}

